var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cell",on:{"click":function($event){return _vm.toChain(_vm.chain.url)}}},[_c('div',{staticClass:"img-container"},[_c('v-img',{attrs:{"src":_vm.mediaHost + _vm.chain.logo,"height":"100%","contain":""}})],1),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.chain.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }